export default __webpack_public_path__ + "static/media/business_boost_sales.0ee0883b.svg";